export interface LanguageOption {
  language: string;
  isSelected: boolean;
  code?: string;
  translationKey?: string;
}
